import {NfcCard, Payment, Platform} from "@variocube/app-api";
import {PaymentView, useCardListener} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useState} from "react";
import {useLocalization} from "../../i18n";

interface PaymentStepProps {
    platform: Platform;
    onCancel: () => void;
    amount: number;
    currency: string;
    requireCardUid?: boolean;
    onPaymentApproved: (payment: Payment, card?: NfcCard) => Promise<void>;
    onPaymentConfirmed: () => void;
    onPaymentConfirmationFailed: () => Promise<void>;
}

export function PaymentStep(props: PaymentStepProps) {
    const {
        onCancel,
        onPaymentApproved,
        onPaymentConfirmed,
        onPaymentConfirmationFailed,
        amount,
        currency,
        requireCardUid,
    } = props;

    const {t, language} = useLocalization();
    const [card, setCard] = useState<NfcCard>();

    useCardListener(setCard);

    const handleInitiate = useCallback(() => setCard(undefined), []);

    const handleVend = useCallback(async (payment: Payment) => {
        if (requireCardUid && !card) {
            console.error("no card was presented, but a card uuid is required.");
            throw new Error("Could not read card UUID.")
        }
        await onPaymentApproved(payment, card);
    }, [requireCardUid, card, onPaymentApproved]);

    return (
        <PaymentView
            onCancel={onCancel}
            strings={t}
            amount={amount}
            currency={currency}
            language={language}
            onInitiate={handleInitiate}
            onVend={handleVend}
            onConfirmed={onPaymentConfirmed}
            onConfirmationFailed={onPaymentConfirmationFailed}
        />
    )
}
